import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import CrossMark from 'components/Icons/CrossMark';
import { RootState } from 'redux/store';
import Modal from '../Modal/Modal';
import { useRouter } from 'next/router';

export default function AfterPayModal({
    openModal = false,
    setOpenModal
}: {
    openModal: boolean;
    setOpenModal: any
}) {
    const router = useRouter();

    const IsNewsletterModal = useSelector(
        (state: RootState) => state.authEvent.IsNewsletterModal
    );


    useEffect(() => {
        setOpenModal(openModal);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModal]);

    useEffect(() => {
        if (IsNewsletterModal) {
            setOpenModal(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [IsNewsletterModal]);

    const closeModal = () => {
        setOpenModal(false);
    };

    const iframeLink = () => {
        if (router.locale == 'au' || router.locale == 'international') {
            return 'https://static.afterpay.com/modal/en_AU-theme-white.html';
        } else if (router.locale == 'ca') {
            return 'https://static.afterpay.com/modal/en_CA-theme-white.html';
        } else if (router.locale == 'nz') {
            return 'https://static.afterpay.com/modal/en_NZ-theme-white.html';
        }
    }

    return openModal ? (
        <Modal
            open={openModal}
            onClose={closeModal}
            className="relative mx-auto md:h-[680px] w-[773px] overflow-hidden bg-white 2xl:mt-[120px] xsm:h-[100%]">
            <span
                className="absolute right-[20px] top-[20px] z-10 cursor-pointer text-brand-black100 transition-colors hover:text-brand-orange"
                onClick={closeModal}>
                <CrossMark fill="currentColor" />
            </span>
            <div className="flex h-full text-brand-black100 mdx:flex-col">
                <iframe className='w-[100%] h-[100%]' src={iframeLink()}></iframe>
            </div>
        </Modal>
    ) : (<></>);
}
